import React from 'react';
import GenerateCss from '../functions/GenerateCss.jsx';
import useSyncCompiledCss from '../hooks/useSyncCompiledCss.jsx';

function Style( { attributes, blockId, setAttributes } ) {
	const unique = blockId
		? `.alpha-info-box-blocks.alpha-info-box-block-${ blockId }`
		: '.wp-block-alphablock-info-box';
	const {
		containerBorder,
		padding,
		background,
		borderRadius,
		margin,
		alignment,
		verticalAlignment,
		minHeight,
		typography,
	} = attributes;

	const CssObj = {
		[ unique ]: [
			GenerateCss.typography( typography ),
			GenerateCss.border( containerBorder ),
			GenerateCss.padding( padding ),
			GenerateCss.background( background ),
			GenerateCss.borderRadius( borderRadius ),
			GenerateCss.margin( margin ),
			GenerateCss.css( 'text-align', alignment ),
			GenerateCss.css( 'align-items', verticalAlignment ),
			GenerateCss.lengthProp( 'min-height', minHeight ),
		],
	};

	const compiledCss = GenerateCss.CompiledCss( CssObj );

	useSyncCompiledCss( compiledCss, setAttributes );

	return <style>{ compiledCss }</style>;
}

export default Style;
